import { render, staticRenderFns } from "./workshopGroupTree.vue?vue&type=template&id=9ddfa7ea&scoped=true&"
import script from "./workshopGroupTree.vue?vue&type=script&lang=js&"
export * from "./workshopGroupTree.vue?vue&type=script&lang=js&"
import style0 from "./workshopGroupTree.vue?vue&type=style&index=0&id=9ddfa7ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddfa7ea",
  null
  
)

export default component.exports